import { CommonButton } from 'Components/Reusable/Buttons/Buttons';
import React, { Fragment } from 'react';
import { withRouter, RouteComponentProps } from 'react-router';
import { Routes } from 'Utils';
import { useStyles } from './timeline.style';
import useMediaQuery from '@material-ui/core/useMediaQuery';
interface ErrorProps extends RouteComponentProps {
	errors: any;
	id?:any,
	timeline?:boolean,
	plan?:any
	// timeline?:boolean,
}
const Error = ({ errors, history,id,timeline,plan}: ErrorProps) => {

	const matches = useMediaQuery('(max-width:440px)');
	const classes = useStyles();
	// eslint-disable-next-line no-console
	console.log("Errors",errors.message,plan?.Subscriptions[0]?.plan)
	const onClick = (id:any) => {
		return history.push(`address/${id}`)
	}
	const upgadeMembership = ( id:any) => {
		return history.push(`/upgrade/${id}`)
	}
	
	
	return (
		<Fragment>
			{
				errors.message ? (

					<div>
						{
							errors.message === "There is no active subscription for this child" || "An active subscription is required to access this feature" ? (
								<div  style={{ display: 'flex', flexDirection: 'column' , alignItems:'center'}}>
									 {
										 errors.message != "An active subscription is required to access this feature" ? 
										 <h4 className={classes.error} >{errors.message}</h4> : (
											 timeline ? (<h4 className={classes.error} style={{textAlign:'center'}} >{`Become a Premium Member to receive a monthly box of tools and toys tailored to  your child's individual needs. Would you like to join?`}</h4>) :
											 <h4 className={classes.error} style={{textAlign:'center'}} >{`Well, Hello there! Become a member to manage your child's milestones. Would you like to join?`}</h4>
											
										 )
										 
									 }
									{
										id &&  (
											plan?.Subscriptions[0]?.plan  ? (
												<CommonButton
												command={timeline ? "Upgrade Membership" : "Become a Member"}
												onClick={() => upgadeMembership(id)}
												common={{
													width: matches ? '241px' : '381.87px',
													height: '48px',
													background: '#7FD6DD',
													radius: '200px',
													color: 'white',
												}}
											/>
											) : (
												<CommonButton
												
										command={timeline ? "Become a Premium Member" : "Become a Member"}
										onClick={() => onClick(id)}
										common={{
											width: matches ? '241px' : '381.87px',
											height: '48px',
											background: '#7FD6DD',
											radius: '200px',
											color: 'white',
											
										}}
										addLineHeight='normal'
										
									/>
											)
										)
									}
								</div>
							) : (
								<div  style={{ display: 'flex', flexDirection: 'column', alignItems:'center' }}>
									<h1>hey</h1>
									<h4 className={classes.error} style={{textAlign:'center'}}>{errors.message}</h4>
									<button className={classes.button} onClick={() => history.push(Routes.Menu)}>
										Go back
								</button>
								</div>
								
							)
						}
					
			</div>
				) : (
					<div style={{ display: 'flex', flexDirection: 'column', alignItems:'center' }}>
						<h4 className={classes.error}>Something unexpected happened.</h4>
						<button className={classes.button} onClick={() => history.push(Routes.Menu)}>
							Go back
						</button>
					</div>
				)
			}
		</Fragment>
	);
};

export default withRouter(Error);
